import Head from "next/head";
import { ReactElement } from "react";
import Layout from "../components/Layout";
import { PropsWithSession } from "./_app";
import { EmptyState } from "@/components/EmptyState";

export default function Page(props: any) {
  return (
    <div>
      <Head>
        <title>404 Not Found</title>
        <meta name="description" content="Generated by create next app" />
      </Head>

      <main className=" h-screen ">
        <EmptyState
          title="Page Not Found"
          subTitle="You may have mistyped the address of the page may have been moved"
        />
      </main>
    </div>
  );
}

Page.getLayout = function getLayout(
  page: ReactElement,
  props: PropsWithSession
) {
  return <Layout {...props}>{page}</Layout>;
};
